// extracted by mini-css-extract-plugin
module.exports = {"label":"CopyButtonLabel_label__KUGr_","confirmation":"CopyButtonLabel_confirmation__flec7","copied":"CopyButtonLabel_copied__IfEJN","normal":"CopyButtonLabel_normal__QndZr"};